import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';

const VerifyPaymentPage: React.FC = () => {
  const [verificationStatus, setVerificationStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [verificationMessage, setVerificationMessage] = useState<string | null>(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const authToken = sessionStorage.getItem('token');
  const transactionId = queryParams.get('transaction_id');
  console.log(transactionId)

  useEffect(() => {
    const verifyPayment = async () => {
      if (!transactionId) {
        setVerificationStatus('error');
        setVerificationMessage('No payment reference found.');
        return;
      }
      if (!authToken) {
        setVerificationStatus('error');
        setVerificationMessage('Authentication token is missing.');
        return;
      }

      try {
        const response = await fetch('https://backend-kyw8.onrender.com/cases/verify-payment', {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${authToken}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ transactionId }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        setVerificationStatus('success');
        setVerificationMessage(result.message || 'Verification successful.');
      } catch (error) {
        setVerificationStatus('error');
        setVerificationMessage(`Error verifying payment. Please contact ksupport.`);
        console.error('Error verifying payment:', error);
      }
    };

    verifyPayment();
  }, [transactionId, authToken]);

  return (
    <div className='main-div'>
      <div className='form-div !max-w-fit flex flex-col gap-6 border border-[#222222] rounded-[20px] p-6'>
        <h2 className='text-black font-semibold text-3xl text-center'>
          Payment Verification
        </h2>
        <div className='text-center'>
          {verificationStatus === 'loading' && (
            <p className='text-[#8b8989] font-normal text-base'>
              Verifying Payment... please do not leave this page.
            </p>
          )}
          {verificationStatus === 'success' && (
            <p className='text-green-600 font-normal text-base'>
              {verificationMessage}
            </p>
          )}
          {verificationStatus === 'error' && (
            <p className='text-red-500 font-normal text-base'>
              {verificationMessage}
            </p>
          )}
          <p className='text-[#8b8989] font-normal text-base mt-4'>
            Return to{' '}
            <Link to='/dashboard' className='text-blue-600 underline'>
              Dashboard
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerifyPaymentPage;